import { Stepper } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

import { builder } from "@/builders";
import { useFakeFeedback } from "@/builders/types/admin-dashboard";
import { EmptySlot } from "@/components/staff/shared/empty-slot";
import { ActivityDataIcon } from "@/svgs/activity-data-icon";

import { UserFeedbackCard } from "./user-feedback-card";

export function UserFeedbackList() {
  const placeholderData = useFakeFeedback();

  const { data = [] } = useQuery({
    queryKey: builder.data.all_feedbacks.$get(),
    queryFn: builder.$use.data.all_feedbacks,
    select: ({ data }) => data,
    placeholderData,
  });

  if (!data.length) {
    return (
      <EmptySlot
        title="No feedbacks"
        description="No feedbacks have been submitted yet."
        src="mail"
      />
    );
  }

  return (
    <Stepper variant="ladder" active={data.length} orientation="vertical">
      {data.map((feedback, index) => (
        <Stepper.Step
          key={index}
          description={<UserFeedbackCard {...feedback} />}
          icon={<ActivityDataIcon width={16} height={16} />}
          completedIcon={<ActivityDataIcon width={16} height={16} />}
        />
      ))}
    </Stepper>
  );
}
